<div
  class="materials-banner-wrapper"
  [ngClass]="{ 'materials-banner-wrapper--reverse': reverse }"
  [style.backgroundColor]="backgroundColor"
>
  <div class="materials-banner-image">
    <div
      class="materials-banner-icon"
      [ngClass]="{
        'materials-banner-icon--blue': backgroundBannerIcon === 'blue',
        'materials-banner-icon--light-blue':
          backgroundBannerIcon === 'light-blue',
        'materials-banner-icon--grey': backgroundBannerIcon === 'grey',
        'materials-banner-icon--green': backgroundBannerIcon === 'green',
      }"
    >
      <hdi-icon
        [iconPrefix]="bannerIconPrefix"
        [iconName]="bannerIconName"
        [color]="Colors.WHITE"
        [size]="Sizes.LARGE"
      ></hdi-icon>
    </div>
    <hdi-image
      [src]="imageSrc ?? ''"
      [alt]="imageAlt ?? ''"
      [title]="imageTitle"
    />
  </div>
  <div class="materials-banner-content">
    <h3>{{ headline }}</h3>
    <div *ngIf="innerHTMLText.length > 0" [innerHTML]="innerHTMLText"></div>
    <div *ngIf="actionsType === 'link'" class="materials-banner-links">
      <ng-container *ngFor="let link of actionArray; index as i">
        <hdi-link
          [label]="link.label | capitalize"
          [title]="link.title ?? ''"
          [type]="link.buttonLayout ? this.getOptionalLinkType(link) : linkType"
          [hrefType]="link.hrefType ?? HrefType.ANGULAR_ROUTE"
          [href]="link.href!"
          [fragment]="link.fragment"
          [video]="link.video"
          [viewport]="viewport"
        ></hdi-link>
      </ng-container>
    </div>
    <div *ngIf="actionsType === 'button'" class="materials-banner-buttons">
      <hdi-button
        *ngFor="let button of actionArray; index as i"
        [label]="button.label | capitalize"
        [title]="button.title ?? ''"
        [type]="buttonType"
        [isWithoutIcon]="true"
        [iconName]="buttonIconName"
        [hrefType]="button.hrefType ?? HrefType.ANGULAR_ROUTE"
        [href]="button.href!"
        [fragment]="button.fragment"
        (clickEvent)="
          button.hrefType === HrefType.OPEN_MODAL_VIDEO &&
            button.video &&
            openModalVideo(button.video)
        "
      ></hdi-button>
    </div>
  </div>
</div>

<hdi-modal
  *ngIf="video"
  [showModal]="showModal"
  [type]="ModalType.VIDEO"
  [videoSrc]="video.videoSrc"
  [videoId]="video.videoId"
  [thumbnailSrc]="video.thumbnailSrc"
  (closeModalTrigger)="showModal = $event"
>
  <div class="header-content">
    <ng-content select=".header-content"></ng-content>
  </div>
  <ng-content></ng-content>
</hdi-modal>
